export default "__VITE_ASSET__9486405d__"